import { CollectionSurveyQuestions } from '@src/generated/hooks';
import { getErrorMessage } from '../utils/validation';

export const validateSingleChoice = (
  question: CollectionSurveyQuestions,
  answer?: string
): string => {
  const { required, type } = question;

  if (type !== 'single_choice') throw new Error('Invalid question type');

  // Not required and no value to validate
  if (!required && !answer) return '';

  // Ensure a valid selection
  const choice = question.choices?.find((choice) => choice.key === answer);
  const isValid = choice !== undefined;

  return isValid ? '' : getErrorMessage(question);
};
